import { request } from './request'
// 获取机构合同分页列表
function getResourceList(data) {
    return request({
        url: '/sys/uniCourse/selectListPage',
        method: 'POST',
        data: data
    })
}

//保存
function resourceSave(data) {
    return request({
        url: '/sys/uniCourse/uniCourseSave',
        method: 'POST',
        data: data
    })
}

//根据合同ID查询机构合同详情
function getResourceById(data) {
    return request({
        url: '/sys/uniCourse/getUniCourseWithCourseList',
        method: 'POST',
        data: data
    })
}

//导出
function exportResource(data) {
    return request({
        url: '/sys/uniCourse/exportData',
        method: 'POST',
        responseType: 'blob',
        data: data
    })
}

//获取产品和模板数据
function getModuleList(data) {
    return request({
        url: '/sys/product/selectListWithModule',
        method: 'POST',
        data: data
    })
}

//获取公司产品分页列表
function getProductList(data) {
    return request({
        url: '/sys/product/selectListPage',
        method: 'POST',
        data: data
    })
}

//导入模板xlsx下载
function downImportTemplate(data) {
    return request({
        url: '/sys/uniCourse/downImportTemplate',
        method: 'POST',
        responseType: 'blob',
        data
    })
}

//通过xlsx 批量导入数据
function importByXlsx(data) {
    return request({
        url: '/sys/uniCourse/importByXlsx',
        method: 'POST',
        headers: { 'Content-Type': 'multipart/form-data' },
        data
    })
}

//根据当前用户的缓存信息导入数据
function importByCache(data) {
    return request({
        url: '/sys/uniCourse/importByCache',
        method: 'POST',
        data
    })
}

//手动更新数据
function activeSyncData(data) {
    return request({
        url: '/sys/uniCourse/activeSyncData',
        method: 'POST',
        data
    })
}

//获取累计合作资源总量
function getTotalResourceCount(data) {
    return request({
        url: '/sys/companyStat/selectCourseTotalCount',
        method: 'POST',
        data
    })
}

//资源访问情况数据
function getResourceVisitCount(data) {
    return request({
        url: '/sys/companyStat/selectCourseVisitCount',
        method: 'POST',
        data
    })
}
//导出资源访问情况数据
function exportCourseVisitCount(data) {
    return request({
        url: '/sys/companyStat/exportCourseVisitCount',
        method: 'POST',
        responseType: 'blob',
        data
    })
}

//查询点击量top的资源数据
function selectTopCourseVisitCount(data) {
    return request({
        url: '/sys/companyStat/selectCourseTopCount',
        method: 'POST',
        data
    })
}
//导出点击量top的资源数据
function exportCourseTopCount(data) {
    return request({
        url: '/sys/companyStat/exportCourseTopCount',
        method: 'POST',
        responseType: 'blob',
        data
    })
}

export default {
    getResourceList,
    resourceSave,
    getResourceById,
    exportResource,
    getModuleList,
    getProductList,
    downImportTemplate,
    importByXlsx,
    importByCache,
    activeSyncData,
    getTotalResourceCount,
    getResourceVisitCount,
    exportCourseVisitCount,
    selectTopCourseVisitCount,
    exportCourseTopCount
}
